module.exports = __webpack_public_path__ + "static/Mathematica-f24439e6a26400e011530a8759a696d5.png";